import React, { useState } from 'react';
import { useTx } from '../../hooks/useTx';
import { useToast } from '../../context/ToastContext';

// Generic admin action card: a few inputs + one button.
// `build(values)` must return an args array, or throw a string to show as an error.
export default function AdminAction({
  title,
  desc,
  fields = [],
  method,
  build,
  btnLabel = 'Submit',
  successMsg = 'Done!',
  danger = false,
  onDone,
}) {
  const { run, pending } = useTx();
  const toast = useToast();
  const [vals, setVals] = useState({});

  const set = (k, v) => setVals((s) => ({ ...s, [k]: v }));

  const submit = () => {
    let args;
    try {
      args = build ? build(vals) : [];
    } catch (e) {
      toast.error(typeof e === 'string' ? e : 'Invalid input.');
      return;
    }
    run({ method, args, successMsg, onDone });
  };

  return (
    <div className="card" style={{ marginBottom: 12 }}>
      <div style={{ fontWeight: 700, fontSize: 14.5 }}>{title}</div>
      {desc && <div className="dim" style={{ fontSize: 12, marginTop: 4 }}>{desc}</div>}

      {fields.map((f) => (
        <div className="field" key={f.key}>
          {f.label && <label>{f.label}</label>}
          <input
            inputMode={f.numeric ? 'decimal' : 'text'}
            placeholder={f.placeholder || ''}
            value={vals[f.key] || ''}
            onChange={(e) => {
              const v = f.numeric ? e.target.value.replace(/[^\d.]/g, '') : e.target.value;
              set(f.key, v);
            }}
          />
        </div>
      ))}

      <div style={{ marginTop: 14 }}>
        <button
          className={`btn ${danger ? 'ghost' : ''}`}
          onClick={submit}
          disabled={pending}
          style={danger ? { color: 'var(--err)', borderColor: 'rgba(255,90,95,0.4)' } : undefined}
        >
          {pending ? <span className={`spin-inline ${danger ? 'light' : ''}`} /> : null}
          {pending ? 'Processing…' : btnLabel}
        </button>
      </div>
    </div>
  );
}
